import { memo, type PropsWithChildren, type ReactNode } from 'react';

import { DrawerHeader } from './DrawerHeader';
import { DrawerFooter } from './DrawerFooter';
import { Container, Content } from './DrawerLayout.styles';

interface Props {
  title: string;
  footer?: ReactNode;
}

export const DrawerLayout = memo(({ title, children, footer }: PropsWithChildren<Props>) => {
  return (
    <Container>
      <DrawerHeader title={title} />
      <Content>{children}</Content>
      {footer && <DrawerFooter>{footer}</DrawerFooter>}
    </Container>
  );
});
